import { FunctionComponent } from "react";
import styles from "../base/styles/CardBasicVertical.module.css";
import { LabelPairedChevronRightSmRegularIcon } from "@deriv/quill-icons";
import { BaseCardRenderProps } from "../base";
import BasicButton from "../../buttons/basic";

const CardVerticalLayout: FunctionComponent<BaseCardRenderProps> = ({
  cardId,
  className,
  size,
  state,
  type,
  focus,
  handleFocus,
  handleBlur,
  isClickable,
  title,
  subtitle,
  description,
  image,
  iconLeft,
  iconRight,
  linkLabel,
  linkIcon,
  linkOnClick,
  primaryVerticalButton,
  secondaryVerticalButton,
  primaryHorizontalButton,
  secondaryHorizontalButton,
}) => {
  return (
    <div
      className={[
        styles.root,
        className,
        isClickable ? "quill-ui-next-component" : "",
      ].join(" ")}
      data-size={size}
      data-state={state}
      data-type={type}
      data-id={cardId}
      role={isClickable ? "button" : undefined}
      tabIndex={isClickable ? 0 : undefined}
      onFocus={handleFocus}
      onBlur={handleBlur}
    >
      {image && (
        <img className={styles.placeholderImage169} alt="" src={image} />
      )}
      <div className={styles.containerBody}>
        {(iconLeft || iconRight) && (
          <div className={styles.containerIcon}>
            {iconLeft && (
              <div className={`${styles.iconLeft} card-icon`}>{iconLeft}</div>
            )}
            {iconRight && (
              <div className={`${styles.iconRight} card-icon`}>{iconRight}</div>
            )}
          </div>
        )}
        <div className={styles.containerContent}>
          {(title || subtitle) && (
            <div className={styles.titlesubtitle}>
              {title && <b className={styles.title}>{title}</b>}
              {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
              <div className={styles.description}>{description}</div>
            </div>
          )}
        </div>
        {linkLabel && (
          <div
            className={`${styles.actionLink} ${
              linkOnClick ? "quill-ui-next-pointer" : ""
            }`}
            onClick={linkOnClick}
          >
            {linkIcon && (
              <div className={`${styles.customIcon} card-icon`}>{linkIcon}</div>
            )}
            <div className={styles.label}>{linkLabel}</div>
            <div className={`${styles.iconChevron} card-icon`}>
              <LabelPairedChevronRightSmRegularIcon />
            </div>
          </div>
        )}
        {(primaryHorizontalButton || secondaryHorizontalButton) && (
          <div className={styles.actionHorizontalButton}>
            {secondaryHorizontalButton && (
              <BasicButton
                {...secondaryHorizontalButton}
                style="secondary"
                width="fill container"
                size={size}
                color="blackWhite"
              />
            )}
            {primaryHorizontalButton && (
              <BasicButton
                {...primaryHorizontalButton}
                style="primary"
                width="fill container"
                size={size}
                color="blackWhite"
              />
            )}
          </div>
        )}
        {(primaryVerticalButton || secondaryVerticalButton) && (
          <div className={styles.actionVerticalButton}>
            {secondaryVerticalButton && (
              <BasicButton
                {...secondaryVerticalButton}
                style="secondary"
                width="fill container"
                size={size}
                color="blackWhite"
              />
            )}
            {primaryVerticalButton && (
              <BasicButton
                {...primaryVerticalButton}
                style="primary"
                width="fill container"
                size={size}
                color="blackWhite"
              />
            )}
          </div>
        )}
      </div>
      {focus && <div className={styles.bgFocus4} />}
    </div>
  );
};

export default CardVerticalLayout;
